export const loginRequest = state => {
  state.loading = true;
};

export const loginSuccess = (state, payload) => {
  state.auth = payload;
  state.language = payload.language;
  state.loading = false;
};

export const loginError = state => {
  state.loading = false;
};

export const registerRequest = state => {
  state.loading = true;
};

export const registerSuccess = state => {
  state.loading = false;
};

export const registerError = state => {
  state.loading = false;
};

export const pdfRequest = state => {
  state.loading = true;
};

export const pdfSuccess = state => {
  state.loading = false;
};

export const projectPDFRequest = state => {
  state.pdfloading = true;
};

export const projectPDFSuccess = state => {
  state.pdfloading = false;
};

export const projectCSVRequest = state => {
  state.csvloading = true;
};

export const projectCSVSuccess = state => {
  state.csvloading = false;
};

export const fileUploadRequest = state => {
  state.fileuploading = true;
};

export const fileUploadSuccess = state => {
  state.fileuploading = false;
};

export const pdfError = state => {
  state.loading = false;
};

export const logout = state => {
  state.auth = null;
  state.project = null;
};

export const windowCreateResponse = (state, payload) => {
  state.loading = false;
  state.windowCreateResponse = payload;
};

export const getProjects = (state, payload) => {
  state.projects = payload;
};

export const getUsers = (state, payload) => {
  state.users = payload;
};

export const getProject = (state, payload) => {
  state.project = payload;
};

export const getWindows = (state, payload) => {
  state.windows = payload
};

export const noWindowsFound = (state) => {
  state.windows = null
};

export const getBom = (state, payload) => {
  state.bom = payload;
};

export const setProject = (state, payload) => {
  state.project = payload;
};

export const setProjectNumWindows = (state, payload) => {
  state.project.numWindows = payload;
};

export const setWindow = (state, payload) => {
  state.window = payload;
};

export const resetProject = (state) => {
  state.project = null;
};

export const getHandles = (state, payload) => {
  state.handles = payload;
};

export const getMotors = (state, payload) => {
  state.motors = payload;
};

export const getProfiles = (state, payload) => {
  state.profiles = payload;
};

export const getInvisitopProfiles = (state, payload) => {
  state.invisitopprofiles = payload;
};

export const getTranslations = (state, payload) => {
  state.translations = payload;
};

export const getVersions = (state, payload) => {
  state.versions = payload;
};

export const setVersion = (state, payload) => {
  state.version = payload;
};

export const setSharedUsers = (state, payload) => {
  state.sharedusers = payload;
};

export const setSharedProjects = (state, payload) => {
  state.sharedprojects = payload;
};

export const getGenericDownloads = (state, payload) => {
  state.genericDownloads = payload;
};

export const setVersions = (state) => {
};

export const resetError = (state) => {
  state.windowCreateResponse = null;
};

export const setErrorList = (state, payload) => {
  if (Object.keys(payload.data)[0] == "NoErrors")
    state.errorlist = null;
  else if (Object.keys(payload.data)[0] == "InvalidFile")
    state.invalidfile = true;
  else
    state.errorlist = payload.data;
};

export const resetErrors = (state) => {
  state.errorlist = null;
}

export const resetInvalidFile = (state) => {
  state.invalidfile = false;
}

export const setLanguage = (state, payload) => {
  state.language = payload
}

export const setWindowSortOptions = (state, payload) => {
  state.windowsortoptions = payload;
}

export const setProjectSortOptions = (state, payload) => {
  state.projectsortoptions = payload;
}

export const setCountries = (state, payload) => {
  state.countries = payload
}

export const setLanguages = (state, payload) => {
  state.languages = payload
}

export const setSysCos = (state, payload) => {
  state.syscos = payload
}


// WEBPACK FOOTER //
// ./src/ClientApp/store/mutations.js